// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XiFnz","menu":"Header_menu__CxTLW","logout":"Header_logout__y88Nj","tablets":"Header_tablets__O+hDn","suggest":"Header_suggest__OytBe"};